/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateAlbumCollectionModelSchema } from "../createOrUpdateAlbumCollectionModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

/**
 * @description Идентификатор созданного выпуска
 */
export const postApiAlbumCollections200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Ошибка валидации | Выпуск уже существует
 */
export const postApiAlbumCollections400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiAlbumCollections401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiAlbumCollections403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiAlbumCollections500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiAlbumCollectionsMutationRequestSchema = z.lazy(() => createOrUpdateAlbumCollectionModelSchema).describe("Тело запроса")

export const postApiAlbumCollectionsMutationResponseSchema = z.lazy(() => postApiAlbumCollections200Schema)